import React, { useState } from "react";
import FadeIn from "react-fade-in";
import MoodCaptureForm from "../Questionnaires/QuestionnaireForms/MoodCapture";
import FilledButton from "../../../InterstellrComponents/FilledButton";
import { SUBMIT_MOOD_CAPTURE } from "../../../Routes";
import { generateURLOptions } from "../../../URLOptions";
import axios from "axios";
import DailyCheckInSuccessModal from "../../../InterstellrModals/DailyCheckInSuccessModal";

const DailyLog = () => {
  const [selectedMood, setSelectedMood] = useState(2);

  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const submitMoodCapture = async (moodType) => {
    await axios
      .post(
        SUBMIT_MOOD_CAPTURE,
        {
          moodType,
          mood: selectedMood,
        },
        {
          headers: generateURLOptions(),
        }
      )
      .then(async (response) => {
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        console.log("Mood Capture Response: ", response);

        if (response.data.success == true) {
          return setOpenSuccessModal(true);
        }
      })
      .catch((error) => {
        console.log("Save Daily Checkin Error: ", error);
        return alert(error);
      });
  };

  return (
    <>
      <DailyCheckInSuccessModal
        isOpen={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        onSubmit={() => {}}
      />
      <div className="container mx-auto flex flex-col justify-center items-center h-full w-full">
        <div className="w-2/3">
          <FadeIn delay={200}>
            <div className="h-[75vh] flex justify-center items-center">
              <MoodCaptureForm
                selectedMood={selectedMood}
                onChange={setSelectedMood}
              />
            </div>

            <FilledButton
              text={"Next"}
              onPress={() => submitMoodCapture("log")}
            />

            <div className="mt-2">
              <FilledButton
                text={"Skip"}
                backgroundColor="transparent"
                textColor="#5153F5"
              />
            </div>
          </FadeIn>
        </div>
      </div>
    </>
  );
};

export default DailyLog;
